// Configuration
import { ADMIN_PRIVATE_WRAPPER } from '@shared/constants/config';

export const FEATURE_STORE_KEY = 'transporte';

export const MODULE_PATHS_CONSTANTS = {
  BASE_ROUTE: 'transporte',
  LISTADO_POLIZAS: 'polizas',
  LISTADO_EMBARQUES: 'embarques',
  LISTADO_EMBARQUES_POLIZA: 'embarques/by-poliza',
  LISTADO_FACTURACION: 'facturaciones',
  FACTURACION_FALLIDA: 'facturacion-fallida',
  SHIPMEN_DETAIL: 'detalle-embarque',
  ID: ':id',
  EMISION_ENDOSO: 'emision-endoso/:assuredCode',
  EMISION_ENDOSO_LINK: 'emision-endoso',
  CATEGORIAS: 'categorias',
  CREAR_CATEGORIA: 'crear-categoria',
  EDITAR_CATEGORIA: 'editar-categoria/:id',
  EDITAR_CATEGORIA_LINK: 'editar-categoria',
  DETALLE_CATEGORIA: 'detalle-categoria/:id',
  DETALLE_CATEGORIA_LINK: 'detalle-categoria',
  EMISION_FALLIDA: 'emision-fallida',
};

export const generateFullModuleRoute = (route: string): string => {
  return `${MODULE_PATHS_CONSTANTS.BASE_ROUTE}/${route}`;
};

export const fullAppPageRoute = (route: string): string => {
  return `${ADMIN_PRIVATE_WRAPPER}/${generateFullModuleRoute(route)}`;
};

export const MODULE_NAVIGATION_MENU = [
  {
    title: 'Transporte',
    collapsed: true,
    collapsable: true,
    activated: true,
    navigationItems: [
      {
        icon: 'pi pi-truck',
        route: generateFullModuleRoute(
          MODULE_PATHS_CONSTANTS.LISTADO_EMBARQUES
        ),
        title: 'Embarques',
        activated: false,
      },
      {
        icon: 'pi pi-shield',
        route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.LISTADO_POLIZAS),
        title: 'Pólizas',
        activated: true,
      },
      {
        icon: 'pi pi-dollar',
        route: generateFullModuleRoute(
          MODULE_PATHS_CONSTANTS.LISTADO_FACTURACION
        ),
        title: 'Facturación',
        activated: true,
      },
      {
        icon: 'pi pi-exclamation-triangle',
        route: generateFullModuleRoute(
          MODULE_PATHS_CONSTANTS.FACTURACION_FALLIDA
        ),
        title: 'Facturación fallida',
        activated: true,
      },
      {
        icon: 'pi pi-exclamation-triangle',
        route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.EMISION_FALLIDA),
        title: 'Emisión fallida',
        activated: true,
      },
      {
        icon: 'pi pi-cog',
        route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CATEGORIAS),
        title: 'Configuración de categorías',
        activated: true,
      },
    ],
  },
];

export const MODULE_ROUTES_NOT_MENU = [
  {
    icon: 'fas fa-chevron-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.SHIPMEN_DETAIL),
    title: 'Detalle del embarque',
    activateRoute: generateFullModuleRoute(
      MODULE_PATHS_CONSTANTS.LISTADO_EMBARQUES
    ),
  },
  {
    icon: 'fas fa-chevron-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.EMISION_ENDOSO),
    title: 'Volver al listado',
    activateRoute: generateFullModuleRoute(
      MODULE_PATHS_CONSTANTS.LISTADO_FACTURACION
    ),
  },
  {
    icon: 'fa-plus',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CREAR_CATEGORIA),
    title: 'Crear categoría',
    activateRoute: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CATEGORIAS),
  },
  {
    icon: 'fas fa-chevron-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.EDITAR_CATEGORIA),
    title: 'Editar categoría',
    activateRoute: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CATEGORIAS),
  },
  {
    icon: 'fas fa-chevron-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.DETALLE_CATEGORIA),
    title: 'Detalle categoría',
    activateRoute: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CATEGORIAS),
  },
];
